import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import MediocreMakersHomepage from './components/Home';
import PrivacyPolicy from './components/Privacy';
import TermsOfService from './components/TOS';
import AdminPage from './components/AdminPage';
import LoginPage from './components/ProfilePage';
import VerifyEmailPage from './components/VerifyEmailAddress';
import ResetPasswordPage from './components/ResetPasswordPage';
import UserProfile from './components/User-Profile';
import PublicUserProfile from './components/user-profile-public';
import Shop from './components/Shop';

const pages = {
  '/': MediocreMakersHomepage,
  '/Profile': LoginPage,
  '/Privacy': PrivacyPolicy,
  '/TOS': TermsOfService,
  '/verify-email': VerifyEmailPage,
  '/reset-password': ResetPasswordPage,
  '/user-profile': UserProfile,
  '/admin': AdminPage,
  '/Shop': Shop,
};

// Animation variants for page transitions
const pageVariants = {
  initial: {
    opacity: 0,
    scale: 0.98,
  },
  in: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.43, 0.13, 0.23, 0.96] // Custom easing
    }
  },
  out: {
    opacity: 0,
    scale: 1.02,
    transition: {
      duration: 0.4,
      ease: [0.43, 0.13, 0.23, 0.96] // Custom easing
    }
  }
};

// Component to render the appropriate page with transition effects
const PageComponent = ({ pathname }) => {
  // Handle public profile routes
  const isPublicProfileRoute = pathname.startsWith('/user-profile/') && pathname.split('/').length === 3;
  
  if (isPublicProfileRoute) {
    const username = pathname.split('/')[2]; // Extract username from URL
    return (
      <motion.div
        key={pathname}
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        className="page-container"
      >
        <PublicUserProfile username={username} />
      </motion.div>
    );
  }
  
  // For regular routes
  const ActivePage = pages[pathname] || Home;
  return (
    <motion.div
      key={pathname}
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      className="page-container"
    >
      <ActivePage />
    </motion.div>
  );
};

const TransitionWrapper = () => {
  const location = useLocation();
  
  return (
    <div className="relative min-h-screen">
      <AnimatePresence mode="wait">
        <PageComponent pathname={location.pathname} key={location.pathname} />
      </AnimatePresence>
    </div>
  );
};

const App = () => {
  useEffect(() => {
    const preventZoom = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-')) {
        e.preventDefault();
      }
    };
    const preventWheelZoom = (e) => {
      if (e.ctrlKey && e.type === 'wheel') e.preventDefault();
    };
    document.addEventListener('keydown', preventZoom);
    document.addEventListener('wheel', preventWheelZoom, { passive: false });
    return () => {
      document.removeEventListener('keydown', preventZoom);
      document.removeEventListener('wheel', preventWheelZoom);
    };
  }, []);

  return (
    <Router>
      <TransitionWrapper />
    </Router>
  );
};

export default App;